import { JsonProperty } from "../../../models/utilities/json-property";

export class UpdateShipmentActionSchedule {

    public stopId : number;

    public travelTime : string|null;

    public distance : number;

    @JsonProperty({ toType: 'datetime-specific' })
    public stopTimeLocal : Date | undefined;

}

export class UpdateRouteScheduleRequest {
    
    @JsonProperty({ toClass: UpdateShipmentActionSchedule, designType: 'array' })
    public entries : UpdateShipmentActionSchedule[] = [];

    public rowVersion : string;

}
